/* ============================================================
   RACEFACTORY — Swatch labels overlay
   Inietta label hardcoded sopra swatch APO per option o_183441.
   Scope: #template-product (classic only, NON service).
   APO renderizza markup client-side: usa MutationObserver.
   ============================================================ */
(function () {
  'use strict';

  var ROOT_ID = 'template-product';

  // RF: mapping hardcode — aggiornare se admin APO cambia swatch / value-id / hash immagine.
  // Mapping value-id → label custom (override esplicito).
  var LABELS = {
    'v_1231490':           'UD',
    'v_183441_lo5xedr6':   'Stealth™'
  };

  // Mapping per hash immagine APO (URL contiene un hash univoco).
  // Stesso hash = stessa immagine = stessa label, indipendentemente da value-id.
  // Funziona anche se l'admin APO ricrea opzioni con nuovi value-id.
  var LABELS_BY_HASH = {
    '48ae0f179d0e6e596299db41cb0f96c37d74dbc77e03fd074b9c0dd50414134b': 'UD',
    '2f52f25447408bc80e4bfa2db50e05bdccf444bc42cf09becdf12c671f619df2': 'Stealth™'
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  function start() {
    var root = document.getElementById(ROOT_ID);
    if (!root) return;

    scan(root);

    if (typeof MutationObserver === 'undefined') return;
    var obs = new MutationObserver(function () { scan(root); });
    obs.observe(root, { childList: true, subtree: true });
  }

  function scan(root) {
    var swatchOptions = root.querySelectorAll('.mw-option--type-swatch');
    for (var i = 0; i < swatchOptions.length; i++) {
      var option = swatchOptions[i];
      option.classList.add('rf-swatch-option');
      var values = option.querySelectorAll('.mw-option__value[data-value-id]');
      for (var j = 0; j < values.length; j++) {
        decorate(values[j]);
      }
    }
  }

  function decorate(valueEl) {
    if (valueEl.querySelector('.rf-swatch-caption')) return;
    var valueId = valueEl.getAttribute('data-value-id');
    var img = valueEl.querySelector('.mw-option__swatch-image');

    var label = LABELS[valueId];
    if (!label && img) {
      var hash = extractHash(img.getAttribute('src') || '');
      if (hash) label = LABELS_BY_HASH[hash];
    }
    if (!label && img) {
      var alt = (img.getAttribute('alt') || '').trim();
      if (alt && !/^https?:\/\//i.test(alt)) label = alt;
    }
    if (!label) return;

    var labelEl = valueEl.querySelector('label.mw-label');
    if (!labelEl) return;

    var caption = document.createElement('span');
    caption.className = 'rf-swatch-caption';
    caption.textContent = label;
    labelEl.appendChild(caption);
  }

  function extractHash(src) {
    // URL es: https://apo-admin.mageworx.com/front/img/<shop>/<HASH64>?width=100&height=100
    var m = src.match(/\/img\/[^\/]+\/([a-f0-9]{32,})/i);
    return m ? m[1] : null;
  }
})();
